export const AUTH_CONSTANTS = {
  AUTH_TOKEN: "token",
  USER_DATA: "users",
  USER_TOKEN: "userToken",
  LOGIN_TYPE: "loginType",
  FIREBASE_TOKEN: "firebaseToken",
  FIREBASE_DATA: "firebaseData",
  APP_VERSION: "version",
  TPS_TOKEN: "tpsToken",
};

export const LOG_IN_TYPE = {
  nucleus: "nucleus",
  google: "google",
};
